import { z } from "zod";

export const OrderRevisionSource = z.enum(["manual", "pdf", "api"]);

export const OrderRevision = z.object({
  public_id: z.string(),
  revision_no: z.number().int().min(1),
  source: OrderRevisionSource,
  /** 変更前スナップショット (null = 新規作成時の初回 revision) */
  before_json: z.unknown(),
  /** 変更後スナップショット */
  after_json: z.unknown(),
  changed_by_public_id: z.string().nullable(),
  note: z.string().nullable(),
  created_at: z.iso.datetime({ offset: true }),
});

export type OrderRevisionDto = z.infer<typeof OrderRevision>;
